export default {"src":"/_next/static/media/logo.af54f061.svg","height":126,"width":558,"blurWidth":0,"blurHeight":0};